import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import router from './router'
import {store, useGlobalStore} from '@/pinia'
import '@/assets/icon/iconfont.css'
import moment from 'moment'
import axios from 'axios'
//import {getDomainChannel} from "@/api/home"; // 引入axios
import {getDomainSetting} from "@/plugins/utils";

moment.locale('zh-cn')

// 活动页仍用相对路径 /web/api/...，走 /api/web 代理
axios.defaults.baseURL = '/api'
Vue.prototype.axios = axios

Vue.config.productionTip = false

async function bootstrap() {
    const globalStore = useGlobalStore()

    let domainSetting = getDomainSetting()
    globalStore.promotion.ChannelID = parseInt(domainSetting.channelId)
    globalStore.site = domainSetting.site
    globalStore.siteInfo = domainSetting
    new Vue({
        store,
        router,
        render: h => h(App)
    }).$mount('#app')
}

bootstrap()

